import { render, staticRenderFns } from "./TravelCost.vue?vue&type=template&id=13543984&scoped=true&"
import script from "./TravelCost.vue?vue&type=script&lang=js&"
export * from "./TravelCost.vue?vue&type=script&lang=js&"
import style0 from "./TravelCost.vue?vue&type=style&index=0&id=13543984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13543984",
  null
  
)

export default component.exports